import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { useApi } from "../../../../../hooks/useApi";
import { authType } from "../../../../../pages/Login";
import { Filters } from "../../../../../pages/Users/UserInfo";
import Loader from "../../../../DefaultStyles/Loader";
import DropDown, { OptionType } from "../../../../Filters/DropDown";
import Search from "../../../../Filters/Search";
import ChatSearchResult, { recentChatBtnClick } from "./OldChatSeachResult";
import RecentChat from "./OldRecentChat";

export default function OldChatSearch() {
  const recentBtnClicked = useRecoilValue(recentChatBtnClick);
  const setBtnClick = useSetRecoilState(recentChatBtnClick);
  const location = useLocation();
  const auth = useRecoilValue(authType);

  console.log("⭐", recentBtnClicked);

  const [page, setPage] = useState(0);
  const [searchValue, setSearchValue] = useState<string | undefined>(
    location?.search !== "" ? location?.search?.substring(1) : ""
  );
  const [dropDownValue, setDropDownValue] = useState<OptionType>({
    value: location?.search !== "" ? "4" : "",
    label: location?.search !== "" ? "PID@파티장@파티원" : "선택",
  });
  const [searchError, setSearchError] = useState<any>(null);
  const [chatId, setChatId] = useState("");
  const [chatIdErrorMsg, setChatIdErrorMsg] = useState<any>(null);

  // 파티 채팅 검색
  const { response, error, loading } = useApi({
    method: "get",
    url:
      searchValue !== "" && !searchValue?.includes("@")
        ? `chat?page=${page}&size=10` +
          (dropDownValue?.value === "1" ? `&partyid=${searchValue}` : ``) +
          (dropDownValue?.value === "2" ? `&uid=${searchValue}&grade=0` : ``) +
          (dropDownValue?.value === "3" ? `&uid=${searchValue}&grade=1` : ``)
        : undefined,
  });

  // 유효한 채팅 ID인지 확인
  const { response: chatIdResponse, error: chatIdError } = useApi({
    method: "get",
    url:
      dropDownValue?.value === "4" &&
      searchValue?.includes("@") &&
      searchValue?.split("@")[1] !== searchValue?.split("@")[2]
        ? `oldchat/correct?partyid=${searchValue?.split("@")[0]}&ownerid=${
            searchValue?.split("@")[1]
          }&uid=${searchValue?.split("@")[2]}`
        : undefined,
  });

  const chatSearchOptionList = [
    { value: "1", label: "PID" },
    { value: "2", label: "파티장 UID" },
    { value: "3", label: "파티원 UID" },
    { value: "4", label: "PID@파티장@파티원" },
  ];

  useEffect(() => {
    if (error) {
      setSearchError(error);
    }
  }, [error]);

  useEffect(() => {
    if (chatIdError) {
      setChatIdErrorMsg(chatIdError);
    }
  }, [chatIdError]);

  useEffect(() => {
    if (chatIdErrorMsg && chatIdErrorMsg?.code && chatIdErrorMsg?.data) {
      toast.error(`${chatIdErrorMsg.data}`, {
        onClose: () => {
          setChatIdErrorMsg(null);
        },
      });
    }
  }, [chatIdErrorMsg]);

  useEffect(() => {
    if (searchError && searchError?.code && searchError?.data) {
      toast.error(`${searchError.data}`, {
        onClose: () => {
          setSearchError(null);
        },
      });
    }
  }, [searchError]);

  useEffect(() => {
    if (chatIdResponse?.status === 200) {
      setBtnClick(true);
      setChatId(searchValue!);
    } else {
      setBtnClick(false);
    }
  }, [chatIdResponse, searchValue, setBtnClick]);

  useEffect(() => {}, [recentBtnClicked]);

  return (
    <>
      <Filters>
        <DropDown
          setDropDownValue={setDropDownValue}
          optionList={chatSearchOptionList}
          dropdownValue={dropDownValue}
          isDisabled={!auth?.chat}
        />

        <Search
          setSearchValue={setSearchValue}
          placeholder="입력"
          isDisabled={dropDownValue?.value ? false : true}
          defaultValue={searchValue}
        />
      </Filters>

      {/* 채팅 검색 결과 */}
      {response?.status === 200 && (
        <ChatSearchResult
          dropDownValue={dropDownValue}
          searchValue={searchValue}
          response={response}
          page={page}
          setPage={setPage}
          setChatId={setChatId}
        />
      )}

      {/* 최근 대화 조회 */}
      {recentBtnClicked && (
        <RecentChat
          dropDownValue={dropDownValue}
          searchValue={searchValue}
          chatId={chatId}
        />
      )}

      {loading && <Loader />}
    </>
  );
}
